const WHATSAPP_URL = `https://wa.me/33604026840?text=Bonjour%2C%20j%27ai%20besoin%20d%27un%20serrurier%20en%20urgence%20%F0%9F%94%91`;

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="nofollow noopener noreferrer"
      aria-label="Contacter Securycles sur WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-[#FFB100] rounded-full shadow-lg hover:scale-110 transition-transform cursor-pointer"
      style={{ animation: "pulse-wa 2s infinite" }}
    >
      <i className="ri-whatsapp-line text-black text-2xl"></i>
      <style>{`
        @keyframes pulse-wa {
          0%, 100% { box-shadow: 0 0 0 0 rgba(255,177,0,0.5); }
          50% { box-shadow: 0 0 0 12px rgba(255,177,0,0); }
        }
      `}</style>
    </a>
  );
}
